import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'

import DataTable from '../../../DataTable'
import EmailUsageStore from './EmailUsageStore'
import Panel from '../../../../UniformComponents/Panel'
import Input from '../../../form/Input'
import Select from '../../../form/Select'
import Button from '../../../../UniformComponents/Button'
import Loader from '../Loader'

@observer
class EmailUsage extends Component {
    year = ''

    constructor(props) {
        super(props)

        const { intranetStore } = props

        intranetStore.store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'emailusage',
                url: '/intranet/emailusage',
                title: 'Email Usage',
            },
        ]

        this.emailUsageStore = new EmailUsageStore(intranetStore.store)
        this.emailUsageStore.init()
    }

    search = () => {
        const { emailUsageStore } = this
        emailUsageStore.getData(this.year)
    }

    render() {
        const { emailUsageStore } = this
        const { clients, changeClient } = emailUsageStore

        return (
            <Fragment>
                <Loader show={emailUsageStore.loading} />
                <Panel style={{ margin: 'auto', marginTop: '20px', width: '1100px', overflow: 'unset' }}>
                    <Input
                        label="Year"
                        onBlur={({ value }) => { this.year = value }}
                    />

                    <br />

                    <Select
                        label="Client"
                        options={clients}
                        placeholder="All"
                        isClearable
                        blurOnClear
                        onBlur={changeClient}
                    />

                    <br />

                    <Button
                        label="Load data"
                        cssClass="regular primary"
                        onClick={this.search}
                    />

                    <br />

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <DataTable
                            store={{}}
                            dataSet={emailUsageStore.filteredData}
                            columns={emailUsageStore.columns}
                            inMemory
                        />
                    </div>
                </Panel>
            </Fragment>
        )
    }
}

export default EmailUsage
